
import { Component, Vue } from "vue-property-decorator";
import Home from "@/slides/Home.vue";
import AboutUs from "@/slides/AboutUs.vue";
import Artwork from "@/slides/Artwork.vue";
import Partners from "@/slides/Partners.vue";
import Team from "@/slides/Team.vue";
import Portfolio from "@/slides/Portfolio.vue";
import Contact from "@/slides/Contact.vue";
import Slide from "@/components/Slide.vue";
import CatalystMenu from "@/components/CatalystMenu.vue";

@Component({
  components: { CatalystMenu, Slide },
})
export default class App extends Vue {
  loadedSlides: { [k: string]: boolean } = {};
  private caseStudiesResizeObserver: ResizeObserver | null = null;
  private boundSyncCaseStudiesBackground: (() => void) | null = null;

  get slides() {
    return {
      Home,
      AboutUs,
      Artwork,
      Portfolio,
      Partners,
      Team,
      Contact,
    };
  }

  setSlideLoaded(key: string) {
    this.$set(this.loadedSlides, key, true);
  }

  private syncCaseStudiesBackground() {
    const wrapper = this.$el.querySelector<HTMLElement>(
      ".case-studies-partners"
    );
    const portfolio = this.$el.querySelector<HTMLElement>("#slide-portfolio");

    if (wrapper && portfolio) {
      wrapper.style.setProperty(
        "--portfolio-background-sticky-top",
        `${-portfolio.getBoundingClientRect().height}px`
      );
    }
  }

  mounted() {
    this.boundSyncCaseStudiesBackground =
      this.syncCaseStudiesBackground.bind(this);

    this.$nextTick(() => {
      const portfolio = this.$el.querySelector<HTMLElement>("#slide-portfolio");
      this.boundSyncCaseStudiesBackground?.();

      if (portfolio) {
        this.caseStudiesResizeObserver = new ResizeObserver(
          this.boundSyncCaseStudiesBackground as () => void
        );
        this.caseStudiesResizeObserver.observe(portfolio);
      }

      window.addEventListener(
        "resize",
        this.boundSyncCaseStudiesBackground as () => void
      );
    });
  }

  destroyed() {
    this.caseStudiesResizeObserver?.disconnect();

    if (this.boundSyncCaseStudiesBackground) {
      window.removeEventListener("resize", this.boundSyncCaseStudiesBackground);
    }
  }
}
